export const SCRIPT_URLS = {
  CORE: {
    // url: 'https://unpkg.com/leaflet@1.1.0/dist/leaflet.js',
    url: 'lib/leaflet.js',
    integrity: 'sha512-mNqn2Wg7tSToJhvHcqfzLMU6J4mkOImSPTxVZAdo+lcPlk+GhZmYgACEe0x35K7YzW1zJ7XyJV/TT1MrdXvMcA=='
  },
  // CLUSTER: {url: 'https://unpkg.com/leaflet.markercluster@1.0.6/dist/leaflet.markercluster.js'}
  CLUSTER: {url: '/lib/leaflet.markercluster.js'}
}

export const CSS_URLS = {
  CORE: {
    url: '/lib/leaflet.css',
    integrity: 'sha512-wcw6ts8Anuw10Mzh9Ytw4pylW8+NAD4ch3lqm9lzAsTxg0GFeJgoAtxuCLREZSC5lUXdVyo/7yfsqFjQ4S+aKw=='
  },
  CLUSTER: {url: '/lib/MarkerCluster.css'},
  // not needed if you use your own iconCreateFunction instead of the default one
  CLUSTER_DEFAULT: {url: '/lib/MarkerCluster.Default.css'}
}



// WEBPACK FOOTER //
// ./src/components/Leaflet/Urls.js